import React from 'react'
import { Row, Col, Button } from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const ErrorTwo = ({title, subTitle}) => {
	const konverseLogoUrl = "https://uploads-ssl.webflow.com/5e960a73ae45f24b7959e93e/5e98af09a264bd68a6f91651_rsz_koverse_logo-p-500.png";
	return (
		<div className={`h-100 white`}>
			<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
				<div>
					<img width="300" className="img-fluid" src={konverseLogoUrl} alt="" />
				</div>
				<div className="container" style={{marginTop: "5%"}}>
                    <Row align="middle">
						<Col xs={24} sm={24} md={8}>
							<h1 className="font-weight-bold mb-4 display-4">Page not found</h1>
							<p className="font-size-md mb-4">We've noticed you lost your way, no worries, we will help you to found the correct path.</p>
							<a href='/home'>
								<Button type="primary" icon={<ArrowLeftOutlined />}>Go Home</Button>
							</a>
						</Col>
						<Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
							<img className="img-fluid mt-md-0 mt-4" src="/images/img-20.png" alt="" />
						</Col>
					</Row>
				</div>
			</div>
		</div>
	)
}

export default ErrorTwo;